export default "/images/brandHeaderCropped.png?c6006857ea651585d5179b6ca6fcb39f";